import React from 'react';
import { useAuth } from '../context/AuthContext';
import { featuresData } from '../data/jobsData';

const Features = () => {
  const { currentUser } = useAuth();

  // Hide Features section when user is logged in
  if (currentUser) {
    return null;
  }

  return (
    <section className="features sec-space obj-width">
      <h2>Need something?</h2>
      <p>Find the perfect job for you with Alacritas.</p>

      <div className="fe-box">
        {featuresData.map((feature) => (
          <div key={feature.id}>
            <img src={feature.icon} alt={feature.title} />
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
